var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chats_data"},[_c('div',{staticClass:"personal_data_wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"chats_cards_wrapper"},[_c('div',{staticClass:"row"},[(_vm.chatData)?_c('ChatComp',{attrs:{"readOnly":"","messages":_vm.chatData}}):_vm._e()],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }